<template>
  <div class="success">
    <div class="layout">
      <div v-if="type==0" class="addBankSuc">
        <img src="@/assets/images/template/success.png">
        <span>恭喜您添加成功</span>
        <p>用户须知：添加完银行卡，可正常存款交易；如果需要进行取款服务，请上传银行卡证明文件，提交认证审核。</p>
        <a v-sa="{'ClickDeposit':{'PType':pageType=='app'?'app端':pageType=='trade'?'H5交易':'用户中心','AccountType':'真实账户','entry':'添加存款银行卡成功-存款'}}" class="submit" @click="goRecharge">去存款</a>
        <p v-if="withdrawBankOrder!=-1" class="size" @click="goAddBankCard">继续添加银行卡资料</p>
        <Chat />
      </div>
      <div v-else-if="type==1">
        <img src="@/assets/images/template/success.png">
        <p>您的账户升级申请已提交，系统将尽快审核</p>
        <a class="submit" @click="goHome">我知道了</a>
      </div>
      <div v-else>
        <img src="@/assets/images/template/success.png">
        <span>提交成功</span>
        <p>客服将在3-5个工作日完成审核，请耐心等待。</p>
        <a class="submit" @click="goHome">{{ pageType=='app'?'去交易':'返回首页' }}</a>
      </div>
    </div>
    <!--取款银行卡已满-->
    <div v-if="isShow" class="popFixed">
      <div class="masking" @click="closePop" />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p>您的取款银行卡数量已满，无需上传银行卡证明文件即可进行取款服务</p>
        </div>
        <div class="btnCon only">
          <span @click="closePop">我知道了</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Chat from '@/view/module/Chat.vue'
import { mapState } from 'vuex'
export default {
  name: 'Success',
  components: { Chat },
  data() {
    return {
      type: this.$route.query.type,
      withdrawBankOrder: this.$route.query.withdrawBankOrder,
      isShow: false
    }
  },
  computed: {
    ...mapState(['pageType'])
  },
  mounted() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
  },
  methods: {
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    closePop() {
      this.isShow = !this.isShow
    },
    goAddBankCard() {
      if (this.withdrawBankOrder == 0) {
        this.toggleFixed()
        this.isShow = true
      } else {
        this.$bus.$emit('loading', false)
        this.$router.replace({ path: '/home/uploadProof', query: { bankOrder: this.withdrawBankOrder }})
      }
    },
    goRecharge() {
      this.$bus.$emit('loading', false)
      this.$router.replace({ path: '/home/recharge' })
    },
    goHome() {
      if (this.pageType == 'app') {
        window.location.href = 'https://www.cfwell.com/?intercept_market'
      } else {
        this.$bus.$emit('loading', false)
        this.$router.replace({ path: '/home' })
      }
    }
  }
}
</script>
